/**
 * Guide engine v3 overlay - error chip (#1025, epic #1020). Spec R11.
 *
 * A small bottom-right chip shown when a step cannot proceed: a highlight never
 * mounted within the timeout, or (wired in #1026) a package load / sandbox setup
 * failure. There is NO retry and NO skip - Exit is the only out, consistent with
 * forward-only. No silent hang.
 */

import { Box, Button, Paper, Typography } from '@mui/material';
import { errorMessage, DEFAULT_GUIDE_STRINGS } from './strings';

const GuideErrorChip = ({ reason, onExit, strings = DEFAULT_GUIDE_STRINGS, zIndex }) => (
  <Paper
    role="alert"
    elevation={0}
    data-testid="guide-error-chip"
    sx={(theme) => ({
      position: 'fixed',
      bottom: theme.ds.space[8],
      right: theme.ds.space[8],
      zIndex,
      maxWidth: 340,
      p: `${theme.ds.space[5]}px ${theme.ds.space[6]}px`,
      bgcolor: theme.palette.surface.overlay,
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.danger.border}`,
      borderRadius: `${theme.ds.radius.container}px`,
      boxShadow: theme.palette.overlay.shadow,
      backgroundImage: 'none',
    })}
  >
    <Typography sx={(theme) => ({
      fontSize: `${theme.ds.font.bar}px`,
      lineHeight: 1.5,
      color: theme.palette.text.secondary,
      mb: `${theme.ds.space[4]}px`,
    })}
    >
      {errorMessage(reason, strings)}
    </Typography>
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button
        onClick={onExit}
        disableElevation
        variant="contained"
        size="small"
        data-testid="guide-error-exit"
        sx={(theme) => ({
          textTransform: 'none',
          minHeight: 32,
          borderRadius: `${theme.ds.radius.button}px`,
          fontSize: `${theme.ds.font.bar}px`,
          bgcolor: theme.palette.buttonPrimary.bg,
          color: theme.palette.buttonPrimary.text,
          '&:hover': { bgcolor: theme.palette.buttonPrimary.bg, filter: 'brightness(1.06)' },
        })}
      >
        {strings.exit}
      </Button>
    </Box>
  </Paper>
);

export default GuideErrorChip;
